// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';

import Domain from './common/Domain';

interface Props {
  domainId: number;
}

const DomainBox = styled.span`
  background: #FFFFFF;
  border-radius: 16px;
  padding: 3px 10px;
  font-size: 12px;
  line-height: 17px;
  color: #313131;

  & + & {
    margin-left: 10px;
  }
`

function DomainLabel({ domainId }: Props): JSX.Element {
  return (
    <DomainBox>
      <Domain id={domainId} />
    </DomainBox>
  )
}

export { DomainLabel as default }
